export const KijijiMyBusinessOpen = 'KijijiMyBusinessOpen'
export const MyAccountOpen = 'MyAccountOpen'
export const MyAccountSettingsOpen = 'MyAccountSettingsOpen'
export const MyAdsOpen = 'MyAdsOpen'
export const MyOrdersOpen = 'MyOrdersOpen'
